import { UserStatus } from "@/api/SolarCloudApi";
import { useEffect } from "react";

import { FormState, useAuthStore } from "@/stores/authStore";
import Verified from "./Verified";
import VerificationForm from "./VerificationForm";
import SignInForm from "./SignInForm";
import SignUpForm from "./SignUpForm";
import { useUser } from "@/queries/user/useUser";
import LoadingSection from "@/components/LoadingSection";

type AuthProcessProps = {
  onVerified: () => void;
  defaultFormState?: FormState;
  handleBack?: () => void;
};

export default function AuthProcess({
  onVerified,
  defaultFormState,
  handleBack,
}: AuthProcessProps) {
  const { formState, setFormState } = useAuthStore();
  const { data: user, isLoading } = useUser();

  useEffect(() => {
    const status = user?.status;

    switch (status) {
      case UserStatus.ACTIVE:
      case UserStatus.PENDING:
      case UserStatus.PROFILED:
      case UserStatus.VERIFIED:
        setFormState(FormState.VERIFIED);
        break;
      case UserStatus.CANCELLED:
      case UserStatus.COMPROMISED:
      case UserStatus.INACTIVE:
        setFormState(FormState.SIGNIN);
        break;
      case UserStatus.UNVERIFIED:
        setFormState(FormState.VERIFICATION);
        break;
      default:
        setFormState(defaultFormState || FormState.SIGNUP);
    }
  }, [user?.status, setFormState, defaultFormState]);

  if (isLoading) {
    return <LoadingSection />;
  }

  return (
    <>
      {formState === FormState.SIGNUP && <SignUpForm handleBack={handleBack} />}
      {formState === FormState.SIGNIN && (
        <SignInForm handleVerified={onVerified} handleBack={handleBack} />
      )}
      {formState === FormState.VERIFICATION && (
        <VerificationForm handleVerified={onVerified} />
      )}
      {formState === FormState.VERIFIED && <Verified onSuccess={onVerified} />}
    </>
  );
}
